import styles from './validationErrorMessage.module.scss'

type Props = {
  message: string
}

export const ValidationErrorMessage = ({ message }: Props) => {
  return <p className={styles.message}>{message}</p>
}
